import React from "react";

import { Section, TitleH1 } from "../../styles/sharedStyles";

import {
  Block,
  BlockDescription,
  BlockTitle,
  Buttons,
  StyledButton,
  Text,
} from "./styles";

export const Services = () => {
  return (
    <Section>
      <TitleH1>Услуги</TitleH1>
      <Block bgcolor="#BCD3FF">
        <BlockTitle>Поиск <br/>работы</BlockTitle>
        <BlockDescription>
          <Text>
                        Для тех, кто не хочет тратить время и силы на поиск, и хочет получить максимальный результат.
                        Для тех, кто хочет найти новую работу с подходящими условиями быстрее.
          </Text>
          <Buttons>
            {/*TODO для новой страницы*/}
            {/*<StyledButton href="/services/c-level">Продвижение ТОП–менеджеров</StyledButton>*/}
            <StyledButton href="/services/career-consult">Карьерная консультация</StyledButton>
            <StyledButton href="/services/search-support">
                            Сопровождение поиска работы
            </StyledButton>
            <StyledButton href="/services/cv-ready">Резюме «Под ключ»</StyledButton>
            <StyledButton href="/services/vacancies">Подписка на ведение вакансий</StyledButton>
            <StyledButton href="/services/linkedin-boost">Развитие LinkedIn профиля</StyledButton>
          </Buttons>
        </BlockDescription>
      </Block>
      <Block bgcolor="#C7E8E8">
        <BlockTitle>Психология <br/>и консалтинг</BlockTitle>
        <BlockDescription>
          <Text>
                    Для тех, кто устал от текущей деятельности, чувствует выгорание или хочет разобраться в себе.
                    Помогаем заглянуть в себя и ответить честно на волнующие вопросы. Углубленная проработка целей,
                    поиск внутренней опоры, систематическая работа с убеждениями и внутренними ограничениями
                    помогает создать план действий для достижения масштабных карьерных целей.
          </Text>
          <Buttons>
            <StyledButton href="/services/talkitout">«Выговориться»</StyledButton>
            <StyledButton href="/services/probation-support">
                        Сопровождение испытательного срока
            </StyledButton>
          </Buttons>
        </BlockDescription>
      </Block>
      <Block bgcolor="#96CFFF">
        <BlockTitle>Подбор <br/>ИТ специалистов</BlockTitle>
        <BlockDescription>
          <Text>
                        Мы разработали три формата пакетного ведения под разные запросы: пассивный поиск, активный поиск
                        и закрытие позиции «под ключ».
          </Text>
          <Buttons>
            <StyledButton href="/services/it-hiring">Подробнее</StyledButton>
          </Buttons>
        </BlockDescription>
      </Block>
      <Block bgcolor="#55749F">
        <BlockTitle isWhite>Обучение <br/>ИТ Рекрутер</BlockTitle>
        <BlockDescription>
          <Text isWhite>
                        Авторский курс Любови Прохоровой – это возможность освоить новую профессию, в которой будет
                        интересно работать. Наши студенты устраиваются на первую работу уже буквально внутри обучения.
          </Text>
          <Buttons>
            <StyledButton
              isWhite
              href="/services/it-training"
            >Подробнее</StyledButton>
          </Buttons>
        </BlockDescription>
      </Block>
    </Section>
  );
};

